var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center image-container"},[_c('router-link',{attrs:{"to":"/login"}},[_c('img',{staticClass:"getting-started-img",attrs:{"src":"assets/getStartedBtn.png","alt":"","height":"210"}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }